/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class AccountService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'AccountService\' loaded');
    }
}

export { AccountService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/service/AccountService.js